module.exports = __webpack_public_path__ + "img/qr_mobil_plus.bb3893f2.png";